import { scrollToIfNeeded } from "@/scripts/common/scroll-to";
import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import { animate } from "motion";
import "./major-keys.css";

document.querySelectorAll(".component-major-keys").forEach(async (el) => {
  const container = el.querySelector(".swiper");
  const sliderButtonNext = el.querySelector(".slider-button-next");
  const majorKeysSlider = el.querySelector(".major-keys-slider");
  const sliderVerticalButtonNext = el.querySelector(".slider-vertical-button-next");
  const numSlides = el.querySelectorAll(".swiper-slide").length;

  const swiper = new Swiper(container, {
    modules: [A11y, Navigation],
    loop: numSlides > 1,
    speed: 800,
    breakpoints: {
      768: {
        enabled: false,
        loop: false,
      },
    },
    on: {
      slideChange: function () {
        const currentRealIndex = this.realIndex;
        const totalSlides = this.slides.length;

        const nextRealIndex = (currentRealIndex + 1) % totalSlides;
        const nextSlide = this.slides.filter(
          (slide) => parseInt(slide.getAttribute("data-swiper-slide-index")) === nextRealIndex,
        )[0];

        if (nextSlide) {
          setTimeout(() => {
            sliderButtonNext.querySelector("[data-title]").textContent = nextSlide.dataset.title;
            sliderButtonNext.querySelector("[data-position]").textContent = nextSlide.dataset.position;
          }, 200);
        }
      },
    },
  });

  if (sliderButtonNext) {
    sliderButtonNext.addEventListener("click", async () => {
      scrollToIfNeeded(container);

      setTimeout(() => {
        swiper.slideNext();
      }, 250);
    });
  }

  if (sliderVerticalButtonNext) {
    sliderVerticalButtonNext.addEventListener("click", async () => {
      const currentSlide = majorKeysSlider.querySelector(".current-slide");
      const nextSlide = currentSlide.nextElementSibling;
      const nextNextSlide = nextSlide.nextElementSibling;

      const baseDistance = 100; // 100% as reference
      const baseDuration = 0.6;

      const currentDistance = 100; // 0% to -100%
      const nextDistance = 15; // -85% to -100%
      const nextNextDistance = 85; // -100% to -185%

      sliderVerticalButtonNext.disabled = true;

      await animate([
        [
          currentSlide,
          { x: ["0%", "-100%"], zIndex: 15 },
          {
            ease: "linear",
            duration: (currentDistance / baseDistance) * baseDuration,
          },
        ],
        [
          nextSlide,
          { x: ["-85%", "-100%"], zIndex: 10 },
          {
            ease: "linear",
            duration: (nextDistance / baseDistance) * baseDuration,
            at: "<",
          },
        ],
        [
          nextNextSlide,
          { x: ["-100%", "-185%"], zIndex: 5 },
          {
            ease: "linear",
            duration: (nextNextDistance / baseDistance) * baseDuration,
            at: "<",
          },
        ],
      ]).finished;

      nextNextSlide.style.transform = "";

      currentSlide.classList.remove("current-slide");
      nextSlide.classList.add("current-slide");

      nextSlide.style = null;
      currentSlide.style = null;
      majorKeysSlider.appendChild(currentSlide);

      sliderVerticalButtonNext.querySelector("[data-title]").textContent = nextNextSlide.dataset.title;
      sliderVerticalButtonNext.querySelector("[data-position]").textContent = nextNextSlide.dataset.position;

      sliderVerticalButtonNext.disabled = false;
    });
  }
});
